var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-flex',{staticClass:"text-xs-left",attrs:{"xs12":""}},[_c('div',{staticClass:"d-inline-flex justify-content-start align-center cursor-pointer font-weight-bold",on:{"click":function($event){return _vm.backSimulator()}}},[_c('v-icon',[_vm._v("mdi mdi-chevron-left")]),_vm._v(" Todos os simuladores ")],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }